export default "__VITE_ASSET__43121997__"